import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const pages = ['Homepage', 'About me', 'Contact'];

export const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const location = useLocation();
  const navigate = useNavigate()
  const navigateToPage = (page: string) => {
    let targetPath = '';
    // Associa ogni pagina a una route specifica
    switch (page) {
      case 'Homepage':
        targetPath = '/homepage';
        break;
      case 'About me':
        targetPath = '/about-me';
        break;
      case 'Contact':
        targetPath = '/contact';
        break;
      default:
        targetPath = '/';
    }
    // Se la pagina selezionata è diversa dalla pagina attuale, naviga
    if (location.pathname !== targetPath) {
      navigate(targetPath);
    }
  };

  return (
    <AppBar
      sx={{
        position: 'relative'
      }}>
      <Container maxWidth="xl">
        <Toolbar
          disableGutters
          sx={{ justifyContent: 'space-evenly' }}
        >
          <Typography
            variant="h5"
            noWrap
            component="a"
            sx={{
              mr: 2,
              display: {xs: 'none', sm: 'none', md: 'flex'},
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
              userSelect: 'none'
            }}
          >
            FRANCESCO ALEMANNO
          </Typography>
          <Typography
            variant="h5"
            noWrap
            component="a"
            sx={{
              mr: 2,
              display: { xs: 'none', sm: 'flex', md: 'none'},
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
              userSelect: 'none'
            }}
          >
            FRANCESCO ALEMANNO
          </Typography>
          <Typography
            variant="h6"
            noWrap
            component="a"
            sx={{
              mr: 2,
              display: { xs: 'flex', sm: 'none', md: 'none'},
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.2rem',
              color: 'inherit',
              textDecoration: 'none',
              userSelect: 'none'
            }}
          >
            FRANCESCO ALEMANNO
          </Typography>
          {/* PER CREARE SPAZIO TRA I DUE BOX IN MODO DINAMICO*/}
          <Box sx={{ flexGrow: 1 }}></Box>
          {/* NAVBAR DISPLAY PICCOLI */}
          <Box sx={{ display: { xs: 'flex', position: 'relative', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{
                transition: 'color 0.3s',
                '&:hover': {
                  color: 'grey',
                },
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiPaper-root': { backgroundColor: 'black' },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={() => {
                    handleCloseNavMenu();
                    navigateToPage(page);
                  }}
                  sx={{
                    backgroundColor: 'black',
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: 'center',
                    }}
                  >{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          {/* NAVBAR DISPLAY GRANDI */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 'none' }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={() => {
                  handleCloseNavMenu();
                  navigateToPage(page);
                }}
                sx={{
                  my: 2,
                  color: 'white',
                  display: 'block',
                  transition: 'color 0.3s',
                  '&:hover': {
                    color: '#C0C0C0', //silver
                  },
                }}
              >
                {page}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default Navbar;
